<div class="popups-container">
  <h2 mat-dialog-title>{{msg}}</h2>

  <mat-dialog-content> </mat-dialog-content>

  <mat-dialog-actions>
    <button
      mat-button
      [mat-dialog-close]="false"
      color="warning"
      [style]="'margin:15px;    padding: 5% 8% 5% 8%;'"
    >
      Nochmal versuchen
    </button>
    <button
      mat-button
      [mat-dialog-close]="true"
      [style]="'margin:15px;    padding: 5% 8% 5% 8%;'"
      class="bg-green"
    >
      Weiter ohne Dienststellencode
    </button>
  </mat-dialog-actions>
</div>
